export const LAST_SELECTED_UPDATES_PAGE_KEY = 'lastSelectedUpdatesPage';
